<script setup>
import { computed, inject, shallowRef, useTemplateRef, ref } from 'vue'
import wrapper from './sla.vue'
import SelectId from '@/components/select/selectIdObject.vue'
import { useToggle } from '@vueuse/core'
import { useUserStore } from '@provise/stores/user.js'
import { useApi } from '@provise/composables/api.js'
import { useMessageStack } from '@provise/stores/messagestack.js'
const userStore = useUserStore()

const rights = {
  coordinator: ['registration', 'correction', 'prepare_to_answer', 'delivery_answer'],
  investigator: ['investigation'],
  signater: ['coordination'],
  supersignater: ['coordination'],
}
const { push: notify } = useMessageStack()
const emit = defineEmits(['extend'])
const wrpr = useTemplateRef('wrpr')
const users = inject('users', () => shallowRef([]), true)
const fusers = computed(() => {
  const sla = wrpr.value.sla.status
  return users.value.filter(u => {
    if (userStore.is('sa', u)) {
      return true
    }
    for (let role of Object.keys(rights)) {
      if (!userStore.is(role, u)) {
        continue
      }
      for (let step of rights[role]) {
        if (sla === step) {
          return true
        }
      }
    }
    return false
  })
})
const sla_started = computed(() => {
  return wrpr.value?.sla.started
})
const [showRequestButton, toggleRequest] = useToggle(false)
const user = computed(() => {
  const u = curru.value
  if (!u) {
    return null
  }
  return u.fio || u.username
})
const [showSelect, toggleSelect] = useToggle(false)
const curru = computed(() => {
  const uid = wrpr.value?.sla.assign_user?.id
  const u = users.value.find(user => uid && user.id == uid)
  if (!u) {
    return null
  }
  return u
})
const newu = ref(null)
async function done(val) {
  const u = users.value.find(us => us.id == val)
  if (!u) {
    return
  }
  if (userStore.can('signater')) {
    await wrpr.value.extend({ assign_user: { id: u.id } })
    if (wrpr.value.sla.assign_user == null) wrpr.value.sla.assign_user = {}
    wrpr.value.sla.assign_user.id = u.id
    emit('extend')
    toggleSelect(false)
  } else {
    newu.value = u
    toggleRequest(true)
  }
}

async function requestUserChange() {
  console.log('Request change on ' + newu.value.username)
  await useApi({
    url: `complaints/sla/${wrpr.value.sla.id}/request_change/${newu.value.id}`,
  }).refresh()
  notify(`Запрос на смену ответственного отправлен`)

  toggleRequest(false)
  toggleSelect(false)
}
</script>
<template>
  <wrapper ref="wrpr" v-bind="$props" #="{ sla }">
    <span v-if="!sla.current_step" class="text-muted fs-6">{{ user }}</span>
    <template v-else>
      <button
        class="btn btn-link btn-sm"
        type="button"
        v-if="!showSelect && curru"
        @click="toggleSelect()"
      >
        {{ user }}
      </button>
      <button
        class="btn btn-link text-danger btn-sm"
        type="button"
        v-else-if="!showSelect && !curru && sla_started"
        @click="toggleSelect()"
      >
        Ответственный не назначен
      </button>
      <template v-else-if="sla_started">
        <div class="d-flex">
          <SelectId
            :options="fusers"
            values="label"
            :search-enabled="false"
            @update:model-value="done"
            :model-value="curru"
            style="width: 16rem"
          />
          <button
            class="btn btn-primary ms-1"
            type="button"
            v-if="showRequestButton"
            @click="requestUserChange()"
          >
            Запросить смену
          </button>
        </div>
      </template>
    </template>
  </wrapper>
</template>
